module.exports = __webpack_public_path__ + "static/img/new6.9462314.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new6.jpeg
// module id = O+mn
// module chunks = 0